import { Button, Dialog, Grid } from '@mui/material';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { SiTrackPage } from '../../../components/si-track-page';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { DetailsTabs } from './details-tabs';
import { WidgetsContainer } from '../widgets-container.component';
import { Project } from '../../../models/project';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { useState } from 'react';
import { useSaveData } from '../../../hooks/useSaveData';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { UserPermissionName } from '../../../models/user-permission-name';
import { GuardedComponent } from '../../../components/guarded-component';
import { useAuthorize } from '../../../hooks/use-authorize';

export const ProjectDetailsPage = () => {
  const { projectID } = useParams();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const { data, isLoading, refetch } = useLoadData<ApiResponse<Project>>(
    projectsApiKeyStore.getProjectDetails(Number(projectID))
  );

  const { isLoading: isLoadingProjectComplete, mutateAsync } = useSaveData<any>(
    projectsApiKeyStore.completeProject(Number(projectID))
  );

  const handleEditProject = () => {
    navigate(`edit`);
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const handleSumbitConfirm = async () => {
    const updatedData = {
      projectID: Number(projectID),
    };
    await mutateAsync({ data: updatedData });
    refetch();
    closeDialog();
  };

  const permissionForTab = {
    unitTab: useAuthorize([UserPermissionName.VIEW_UNIT]),
    contactTab: useAuthorize([UserPermissionName.VIEW_CONTACT]),
    serviceTab: useAuthorize([UserPermissionName.VIEW_SERVICE_PROJECT]),
    serviceBundleTab: useAuthorize([UserPermissionName?.VIEW_SERVICE_BUNDLE]),
    workorders: useAuthorize([UserPermissionName.VIEW_WORKORDER]),
    planTab: useAuthorize([UserPermissionName.VIEW_PLAN]),
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <SiTrackPage
      title={data?.data?.projectName ?? ''}
      onEdit={!data?.data?.isCompleted ? handleEditProject : undefined}
      isLoading={isLoading}
      actionPermissions={{ edit: UserPermissionName.EDIT_PROJECT }}
    >
      <Grid display={'flex'} justifyContent={'flex-end'}>
        <GuardedComponent requiredPermissions={[UserPermissionName.COMPLETE_PROJECT]}>
          <Button
            type="button"
            disabled={isLoading || data?.data?.isCompleted || isReadOnlyPermission}
            variant="contained"
            style={{ width: '130px' }}
            className="btn btn-sm btn-success"
            onClick={() => setOpenDialog(true)}
          >
            Complete
          </Button>
        </GuardedComponent>
      </Grid>
      <WidgetsContainer projectID={projectID} />
      {!permissionForTab?.serviceBundleTab &&
        !permissionForTab?.unitTab &&
        !permissionForTab?.contactTab &&
        !permissionForTab?.serviceTab &&
        !permissionForTab?.workorders &&
        !permissionForTab?.planTab ? null : (
        <Grid container justifyContent="space-between" spacing={3} style={{ paddingBottom: '10px' }}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <DetailsTabs
              customerID={data?.data.customerID}
              permissionForTab={permissionForTab}
              officeID={data?.data.officeID}
              isNotCompleted={!data?.data?.isCompleted}
              projectContact={data?.data?.projectContacts}
              pricingListID={data?.data?.pricingListID}
            />
          </Grid>
        </Grid>
      )}
      {openDialog && (
        <Dialog
          open={openDialog}
          className="modalpopup"
          title={'CONFIRM STATUS'}
        // onClose={closeDialog}
        >
          <div>
            <div style={{ padding: '25px 50px' }}>
              <div>
                Continuing will permanently close out the project (community) not allowing any additional work, such as
                adding lots, to be performed. Are you sure that you want to continue?
              </div>
              <LoadingIndicator isLoading={isLoadingProjectComplete} />
            </div>
          </div>
          <DialogActionsBar>
            <div className=" spaceBetween">
              <button
                style={{ cursor: 'pointer' }}
                className="btn btn-sm btn-default btn-lightGrey"
                onClick={closeDialog}
                autoFocus
              >
                Cancel
              </button>

              <button
                className="btn btn-sm btn-primary  btn-delete"
                style={{
                  backgroundColor: isReadOnlyPermission ? '#D7DBDD' : '#0000b5',
                  color: isReadOnlyPermission ? 'black' : '#fff', cursor: 'pointer'
                }}
                type="button"
                onClick={handleSumbitConfirm}
                disabled={isLoading || isReadOnlyPermission}
              >
                Confirm
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
      <Outlet />
    </SiTrackPage>
  );
};
